import { useEffect, useState } from "react";
import { PackagePlus } from "lucide-react";
import { api } from "@/lib/api";
import { act } from "@/lib/hooks";
import { Field } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function BulkStockDialog({ items, open, onOpenChange, onSaved }: { items: any[]; open: boolean; onOpenChange: (v: boolean) => void; onSaved: () => void }) {
  const parts = items.filter((i) => i.kind === "part" && i.active);
  const [qty, setQty] = useState<Record<string, string>>({});
  const [reason, setReason] = useState("Inventaire initial");
  const [q, setQ] = useState("");
  useEffect(() => {
    if (open) {
      setQty({});
      setReason("Inventaire initial");
      setQ("");
    }
  }, [open]);
  const lines = Object.entries(qty).filter(([, v]) => Number(v) > 0).map(([item_id, v]) => ({ item_id, qty: Number(v) }));
  const save = async () => {
    if (await act(() => api.post("/stock/bulk-entry", { reason, lines }), `${lines.length} pièce(s) entrée(s) en stock`)) {
      onSaved();
      onOpenChange(false);
    }
  };
  const shown = parts.filter((p) => !q || `${p.label} ${p.code}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="bulk-stock-dialog">
        <DialogHeader><DialogTitle className="font-display uppercase">Entrée de stock groupée</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <Field label="Motif"><Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Inventaire initial, livraison fournisseur…" data-testid="bulk-reason-input" /></Field>
          <Field label="Rechercher"><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Huile, filtre…" data-testid="bulk-search-input" /></Field>
        </div>
        <div className="max-h-[50vh] space-y-1 overflow-y-auto">
          {shown.map((p) => (
            <div key={p.id} className="grid grid-cols-[1fr_90px_110px] items-center gap-3 border-b border-border py-2 text-sm" data-testid={`bulk-row-${p.id}`}>
              <span>{p.label}</span>
              <span className="text-xs text-muted-foreground">Stock : {p.stock_qty}</span>
              <Input type="number" min={0} step="any" value={qty[p.id] || ""} onChange={(e) => setQty({ ...qty, [p.id]: e.target.value })} placeholder="+ Qté" className="h-10 font-mono-data" data-testid={`bulk-qty-${p.id}`} />
            </div>
          ))}
          {!shown.length && <p className="py-6 text-center text-sm text-muted-foreground">Aucune pièce. Créez-la d'abord avec « + Article ».</p>}
        </div>
        <Button className="h-11" disabled={!lines.length || reason.trim().length < 2} onClick={save} data-testid="bulk-save-btn">
          <PackagePlus className="mr-2 h-4 w-4" />Entrer {lines.length} pièce(s) en stock
        </Button>
      </DialogContent>
    </Dialog>
  );
}
